// src/pages/FAQ.jsx
import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import "../Css/FAQ.css";


import faqImg from "../assets/faq_1_1.png"; // your image

const faqData = [
  {
    q: "What kind of patient care services do your maids provide?",
    a: "Our trained maids assist with daily care for patients, including helping with mobility, medication reminders, hygiene, and providing companionship."
  },
  {
    q: "Can your maids handle baby care and housekeeping at the same time?",
    a: "Yes! Our maids are skilled in baby care, feeding, and monitoring, as well as house cleaning and maintaining a tidy home, ensuring both tasks are managed efficiently."
  },
  {
    q: "Are your maids trained in cooking?",
    a: "Absolutely. Our maids can prepare meals according to your family’s preferences, manage kitchen hygiene, and ensure nutritious and timely meals."
  },
  {
    q: "Do you provide maids for driving and errands?",
    a: "Yes, we offer trained drivers and japa maids who can safely drive your vehicle, run errands, and assist with household tasks as needed."
  }
];


const FAQ = () => {


    const [activeIndex, setActiveIndex] = useState(null);
    const faqRef = useRef(null);


  useEffect(() => {
  const counters = document.querySelectorAll(".count");
  let started = false;

  const runCounter = () => {
    if (started) return;
    started = true;

    counters.forEach(counter => {
      const target = +counter.getAttribute("data-target");
      let count = 0;
      const speed = target > 100 ? 20 : 200;

      const updateCount = () => {
        count += Math.ceil(target / speed);
        if (count < target) {
          counter.innerText = count;
          setTimeout(updateCount, 20);
        } else {
          // Final value formatting
          if (target === 8) {
            counter.innerText = target + "y+";
          } else {
            counter.innerText = target + "+";
          }
        }
      };

      updateCount();
    });
  };






  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        runCounter();
      }
    },
    { threshold: 0.3 }
  );

  const section = document.querySelector(".FAQ-stats-wrap");
  if (section) observer.observe(section);

  return () => observer.disconnect();
}, []);





  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("faq-visible");
          observer.unobserve(entry.target); // animate only once
        }
      },
      { threshold: 0.25 }
    );

    if (faqRef.current) observer.observe(faqRef.current);
  }, []);

  return (
    <>

    <Helmet>
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqData.map((item) => ({
        "@type": "Question",
        "name": item.q,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": item.a
        }
      }))
    })}
  </script>
</Helmet>

      {/* ================= HERO SECTION ================= */}
      <section className="FAQ-hero">
        <div className="FAQ-overlay">
          <div className="FAQ-hero-content">
            <h1>FAQ</h1>
            <p>
              <span><a href="/">Home</a></span> / <span className="active">FAQ</span>
            </p>
          </div>
        </div>
      </section>


 
    <section className="faq-section" ref={faqRef}>

      <div className="faq-container">

        {/* LEFT CONTENT */}
        <div className="faq-left">
          <span className="faq-tag">FAQ</span>
          <h2 className="faq-title">
            Frequently Asked Have Any Questions
          </h2>

          {/* IMAGE FOR MOBILE */}
          <div className="faq-image-mobile">
            <img src={faqImg} alt="FAQ Maid" />
          </div>

          <div className="faq-list">
            {faqData.map((item, index) => (
              <div
  key={index}
  className={`faq-item ${activeIndex === index ? "active" : ""}`}
  onClick={() =>
    setActiveIndex(activeIndex === index ? null : index)
  }
>
  <span className="faq-underline"></span>

  <div className="faq-question">
    <h4>{item.q}</h4>
    <span className="faq-icon">
      {activeIndex === index ? "−" : "+"}
    </span>
  </div>

  <div className="faq-answer">
    <p>{item.a}</p>
  </div>
</div>

            ))}
          </div>
        </div>

        {/* IMAGE FOR DESKTOP */}
        <div className="faq-right">
          <img src={faqImg} alt="FAQ Maid Service" />
        </div>

      </div>
    </section>


    <div className="faq-links">
  <a href="/services">Our Services</a>
  <a href="/contact">Contact Us</a>
  <a href="/services/house-maid">House Maid Service</a>
  <a href="/services/baby-care">Baby Care Service</a>
</div>


    </>
  );
};

export default FAQ;
